import { lazy } from 'react';

export const LazyNothingToSignPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--nothing-to-sign-page" */ './nothing-to-sign-page'
    ),
);
